import React from 'react';

const useResponsiveColumns = () => {
  const [columns, setColumns] = React.useState(3); // default to desktop

  React.useEffect(() => {
    const updateColumns = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setColumns(2); // mobile
      } else {
        setColumns(3); // tablet and up
      }
    };

    updateColumns();
    window.addEventListener('resize', updateColumns);
    return () => window.removeEventListener('resize', updateColumns);
  }, []);

  return columns;
};

export default useResponsiveColumns;